import { call, put, takeEvery, fork, all } from 'redux-saga/effects';
import axios from 'axios';



function * indexCustomDealFieldsAsync(data){
  try{
    const api = yield call([axios, axios.get], '/api/deals/custom_fields')
    yield put({type:'REQUEST_INDEX_CUSTOM_DEAL_FIELDS_SUCCESS', val:api.data})
  }catch(error){console.log(error, 'ERROR');
    yield put({type:'REQUEST_ERROR', val:error.response})
  }
}

function * createCustomDealFieldAsync(data){
  try{
    const api = yield call([axios, axios.post], '/api/deals/custom_fields', data.data)
    yield put({type:'REQUEST_CREATE_CUSTOM_DEAL_FIELD_SUCCESS', val:api.data});
    yield put({type:'REQUEST_FORM_COMPLETED', val:true});
  }catch(error){console.log(error, 'ERROR');
    yield put({type:'REQUEST_FORM_ERROR', val:error.response})
  }
}
function * updateCustomDealFieldAsync(data){
  try{
    const api = yield call([axios, axios.put], '/api/deals/custom_fields/'+data.id, data.data)
    yield put({type:'REQUEST_UPDATE_CUSTOM_DEAL_FIELD_SUCCESS', val:api.data});
    yield put({type:'REQUEST_FORM_COMPLETED', val:true});
  }catch(error){console.log(error, 'ERROR');
    yield put({type:'REQUEST_FORM_ERROR', val:error.response})
  }
}
function * deleteCustomDealFieldAsync(data){
  try{
    const api = yield call([axios, axios.delete], '/api/deals/custom_fields/'+data.id, data.data)
    if(api.data.deleted_id!=undefined){
      yield put({type:'REQUEST_DELETE_CUSTOM_DEAL_FIELD_SUCCESS', val:api.data.deleted_id});
    }else if(api.data.custom_deal_field!=undefined){
      yield put({type:'REQUEST_UPDATE_CUSTOM_DEAL_FIELD_SUCCESS', val:api.data.custom_deal_field});
    }
  }catch(error){console.log(error, 'ERROR');
    yield put({type:'REQUEST_ERROR', val:error.response})
  }
}


function* Index_custom_deal_fields(){yield takeEvery('REQUEST_INDEX_CUSTOM_DEAL_FIELDS', indexCustomDealFieldsAsync);}
function* Create_custom_deal_field(){yield takeEvery('REQUEST_CREATE_CUSTOM_DEAL_FIELD', createCustomDealFieldAsync)}
function* Update_custom_deal_field(){yield takeEvery('REQUEST_UPDATE_CUSTOM_DEAL_FIELD', updateCustomDealFieldAsync);}
function* Delete_custom_deal_field(){yield takeEvery('REQUEST_DELETE_CUSTOM_DEAL_FIELD', deleteCustomDealFieldAsync)}


function* Index_deals(){yield takeEvery('REQUEST_INDEX_DEALS', indexDealsAsync);}
function* Create_deal(){yield takeEvery('REQUEST_CREATE_DEAL', createDealAsync)}
function* Update_deal(){yield takeEvery('REQUEST_UPDATE_DEAL', updateDealAsync)}
function* Delete_deal(){yield takeEvery('REQUEST_DELETE_DEAL', deleteDealAsync)}


function * indexDealsAsync(data){
  try{
    const api = yield call([axios, axios.get], '/api/deals?company_id='+data.company_id)
    yield put({type:'REQUEST_INDEX_DEALS_SUCCESS', val:api.data, company_id:data.company_id});
    yield put({type:'REQUEST_SALES_COACH_REFRESH'});
  }catch(error){console.log(error, 'ERROR');
    yield put({type:'REQUEST_ERROR', val:error.response})
  }
}

function * createDealAsync(data){
  try{
    const api = yield call([axios, axios.post], '/api/deals', data.data)
    yield put({type:'REQUEST_CREATE_DEAL_SUCCESS', val:api.data.deal});
    yield put({type:'UPDATE_SCORECARD_CREATE_DEAL', val:api.data.deal});
    if(api.data.timeline_items.length>0){yield put({type:'REQUEST_TIMELINE_ITEM_CHECKLIST_SUCCESS', val:api.data});}
    if(api.data.company!=undefined){yield put({type:'REQUEST_COMPANY_UPDATE_SUCCESS', val:api.data.company});}
    yield put({type:'REQUEST_FORM_COMPLETED', val:true});
  }catch(error){console.log(error, 'ERROR');
    yield put({type:'REQUEST_FORM_ERROR', val:error.response})
    yield put({type:'REQUEST_DEAL_LOADING', val:false});
  }
}

function * updateDealAsync(data){
  try{
    const api = yield call([axios, axios.put], '/api/deals/'+data.id, data.data)
    if(api.data.deal!=undefined){
      yield put({type:'UPDATE_SCORECARD_UPDATE_DEAL', val:api.data.deal});
      yield put({type:'REQUEST_UPDATE_DEAL_SUCCESS', val:api.data.deal});}
    if(api.data.deals!=undefined){for(let deal of api.data.deals){
      yield put({type:'UPDATE_SCORECARD_UPDATE_DEAL', val:deal});
      yield put({type:'REQUEST_UPDATE_DEAL_SUCCESS', val:deal});}}
    yield put({type:'REQUEST_SALES_COACH_REFRESH'});
    if(api.data.timeline_items!=undefined && api.data.timeline_items.length>0){yield put({type:'REQUEST_TIMELINE_ITEM_CHECKLIST_SUCCESS', val:api.data});}
    if(api.data.company!=undefined){yield put({type:'REQUEST_COMPANY_UPDATE_SUCCESS', val:api.data.company});}
    if(api.data.deleted_timeline_items!=undefined){for(let ti of api.data.deleted_timeline_items){
      yield(put({type:'REQUEST_TIMELINE_ITEM_DELETE_SUCCESS', val:ti}));
    }}
    if(api.data.quizz!=null && api.data.quizz!=undefined){
      yield put({type:'REQUEST_UPDATE_QUIZZ_SUCCESS', val:api.data.quizz});
    }
    yield put({type:'REQUEST_FORM_COMPLETED', val:true});
  }catch(error){console.log(error, 'ERROR');
    yield put({type:'REQUEST_FORM_ERROR', val:error.response});
    yield put({type:'REQUEST_DEAL_LOADING', val:false});
  }
}

function * deleteDealAsync(data){
  try{
    const api = yield call([axios, axios.delete], '/api/deals/'+data.id)
    yield put({type:'REQUEST_DELETE_DEAL_SUCCESS', val:api.data});
    for(let ti of api.data.deleted_timeline_items){
      yield(put({type:'REQUEST_TIMELINE_ITEM_DELETE_SUCCESS', val:ti}));
    }
  }catch(error){console.log(error, 'ERROR');
    yield put({type:'REQUEST_ERROR', val:error.response})
  }
}

function* Delete_deal_pipeline(){yield takeEvery('REQUEST_DELETE_DEAL_PIPELINE', deleteDealPipelineAsync)}
function* Create_deal_pipeline(){yield takeEvery('REQUEST_CREATE_DEAL_PIPELINE', createDealPipelineAsync)}
function* Update_deal_pipeline(){yield takeEvery('REQUEST_UPDATE_DEAL_PIPELINE', updateDealPipelineAsync)}


function * deleteDealPipelineAsync(data){
  try{
    const api = yield call([axios, axios.delete], '/api/deal_pipelines/'+data.id, data.data)
    yield put({type:'REQUEST_INDEX_DEAL_PIPELINES_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');
    yield put({type:'REQUEST_ERROR', val:error.response})
  }
}

function * createDealPipelineAsync(data){
  try{
    const api = yield call([axios, axios.post], '/api/deal_pipelines', data.data)
    yield put({type:'REQUEST_CREATE_DEAL_PIPELINE_SUCCESS', val:api.data});
    yield put({type:'REQUEST_FORM_COMPLETED', val:true});
  }catch(error){console.log(error, 'ERROR');
    yield put({type:'REQUEST_FORM_ERROR', val:error.response})
  }
}
function * updateDealPipelineAsync(data){
  try{
    const api = yield call([axios, axios.put], '/api/deal_pipelines/'+data.id, data.data)
    yield put({type:'REQUEST_UPDATE_DEAL_PIPELINE_SUCCESS', val:api.data});
    yield put({type:'REQUEST_FORM_COMPLETED', val:true});
  }catch(error){console.log(error, 'ERROR');
    yield put({type:'REQUEST_FORM_ERROR', val:error.response})
  }
}

function* Index_deal_pipelines(){yield takeEvery('REQUEST_INDEX_DEAL_PIPELINES', indexDealPipelinesAsync)}

function * indexDealPipelinesAsync(data){
  try{
    const api = yield call([axios, axios.get], '/api/deal_pipelines', data.data)
    yield put({type:'REQUEST_INDEX_DEAL_PIPELINES_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');
    yield put({type:'REQUEST_ERROR', val:error.response})
  }
}



export default function* Root_deals(){
  yield all([
    fork(Delete_deal_pipeline),
    fork(Create_deal_pipeline),
    fork(Update_deal_pipeline),
    fork(Index_deal_pipelines),
    fork(Index_custom_deal_fields),
    fork(Create_custom_deal_field),
    fork(Update_custom_deal_field),
    fork(Delete_custom_deal_field),
    fork(Index_deals),
    fork(Create_deal),
    fork(Update_deal),
    fork(Delete_deal)
  ])}
